import camelCase                  from 'lodash/camelCase'
import BmiMixin                   from '../../support/bmi_mixin'
import GlucoseIndicatorMixin      from '../../support/glucose_indicator_mixin'
import ScrollToErrorMixin         from '../../support/scroll_to_error_mixin'
import WizardController           from '../wizard_controller'
import SmokingHabitsMixin         from '../medical_histories/smoking_habits_mixin'
import BloodPressureCheckMixin    from '../../support/blood_pressure_check_mixin'
import mixin                      from '../../support/mixin'

export default class extends mixin(
  WizardController,
  BmiMixin,
  GlucoseIndicatorMixin,
  BloodPressureCheckMixin,
  SmokingHabitsMixin,
  ScrollToErrorMixin
) {

  static targets = [
    ...super.targets,
    'hivConfirmationTestResultInconclusive',
    'hivConfirmationTestResultReactive',
    'hivTestResult',
    'nestedTextInput',
    'nestedTextTemplate',
    'nestedTextWrapper',
    'patientHistoryConditionsNoneOfTheAbove',
    'pregnancyStatus',
    'pregnancyWeeks',
    'singleCheckBoxDetails'
  ]

  // ==== Controllers

  // ==== Actions

  // Pregnancy status
  togglePregnancyTestTaken(event) {
    [
      { value: 'patient_pregnancy_tested_today', target: this.pregnancyStatusTarget },
      { value: 'patient_declared_pregnancy_status', target: this.pregnancyWeeksTarget }
    ].forEach((obj) => {
      if (event.currentTarget.value === obj.value) {
        this.showRadioButtonMoreDetails({
          target: obj.target
        })
      } else {
        this.hideRadioButtonMoreDetails({
          target: obj.target
        })
      }
    })
  }

  // HIV status
  toggleHivTestTaken(event) {
    if (event.currentTarget.value === 'patient_hiv_tested_today') {
      this.showRadioButtonMoreDetails({
        target: this.hivTestResultTarget
      })
    } else {
      this.hideRadioButtonMoreDetails({
        target: this.hivTestResultTarget
      })
    }
  }

  toggleHivTestResult(event) {
    [
      { value: 'reactive', target: this.hivConfirmationTestResultReactiveTarget },
      { value: 'inconclusive', target: this.hivConfirmationTestResultInconclusiveTarget }
    ].forEach((obj) => {
      if (event.currentTarget.value === obj.value) {
        this.showRadioButtonMoreDetails({
          target: obj.target
        })
      } else {
        this.hideRadioButtonMoreDetails({
          target: obj.target
        })
      }
    })
  }

  // History of conditions
  toggleFamilyConditionsSelections({ currentTarget: { checked }, params: { condition } }) {
    const targetKey = camelCase(`${condition}_target`)

    if (this[camelCase(`has_${targetKey}`)]) {
      this[targetKey].classList.toggle(this.hideClass, !checked)
    }
  }

  toggleFamilyConditionsSelectionDetails({ currentTarget: { checked }, params: { familyMember } }) {
    const targetKey = camelCase(`${familyMember}_target`)

    if (this[camelCase(`has_${targetKey}`)]) {
      this[targetKey].classList.toggle(this.hideClass, !checked)
    }
  }

  // === Nested sections
  addNestedTextInputItem() {
    this.addNestedForm({
      list:     this.nestedTextInputTargets,
      template: this.nestedTextTemplateTarget,
      wrapper:  this.nestedTextWrapperTarget
    })
  }

  removeNestedTextInputItem(event) {
    const currentTarget = event.currentTarget

    this.removeNestedForm({
      button:  currentTarget,
      wrapper: this.nestedTextWrapperTarget,
      list:    this.nestedTextInputTargets
    })

    if (this.hasConsultationNoteOutlet) {
      this.consultationNoteOutlet.autoSave(event)
    }
  }

  toggleSingleCheckBoxDetails({ currentTarget }) {
    this.toggleNoneInverseSelection({
      input:  currentTarget,
      target: this.singleCheckBoxDetailsTarget
    })
  }

  toggleNoneOfTheAbove({ currentTarget, params: { sectionType } }) {
    const targetsKey = camelCase(`${sectionType}_none_of_the_above_targets`)

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this[targetsKey],
      dispatchInput: false
    })
  }

  // ==== Getters
  get hideClass() {
    return 'u-hide'
  }

  // ==== Setters

  // ==== Private

  // ==== Channels

}
